import {
    downloadFile,
    encodeURLWithParams,
    mapPaginationParamsToServer,
    format,
    isArray,
} from "@/shared";

export const exportStoreSelling = async (paginationParams, filters = {}) => {
    const url = encodeURLWithParams("/stock/export", {
        ...mapPaginationParamsToServer(paginationParams),
        point_id: isArray(filters.points)
            ? filters.points.map(({ id }) => id)
            : null,
    });

    const fileName = `exported_store_selling_${format(
        new Date(),
        "dd_MM_yyyy-HH_mm"
    )}`;

    await downloadFile(url, fileName);
};
